module.exports = __webpack_public_path__ + "static/media/suite.408786de.mp3";